import { createStore } from 'vuex'
import router from './router.js'
import VueCookies from 'vue-cookies'
import axios from 'axios'

window.culligan = window.culligan || {}

export default createStore({
  state() {
    return {
      initialized: false,
      isProcessing: false,
      cookieName: 'culligan',
      pluginUrl: window.culligan.pluginUrl,
      themeUrl: window.culligan.themeUrl,
      currentStep: 'home',
      cart: [],
      productFilters: {
        brand: null,
        category: null,
        flavor: null,
        size: null
      },
      siteName: null,
      offer: null,
      offers: [],
      pages: [],
      products: [],
      productBrands: [],
      productCategories: [],
      productFlavors: [],
      productSizes: [],
      bottleFreeCoolers: [],
      gallonWater: [],
      gallonWaterCoolers: [],
      settings: {
        deliveryFee: null,
        fuelSurcharge: null,
        refundPolicy: null,
      },
    }
  },
  mutations: {
    initialize(state, config) {
      // Load cart state from cookie
      if (this.app.$cookies.isKey(state.cookieName)) {
        state.cart = Object.assign(state.cart, this.app.$cookies.get(state.cookieName))
      }

      // Load offer state from cookie
      if (this.app.$cookies.isKey(state.cookieName + '-offer')) {
        state.offer = this.app.$cookies.get(state.cookieName + '-offer')
      }

      state.siteName           = config.siteName
      state.offers             = config.offers || []
      state.products           = config.products
      state.productBrands      = config.productBrands
      state.productCategories  = config.productCategories
      state.productFlavors     = config.productFlavors
      state.productSizes       = config.productSizes
      state.gallonWaterCoolers = config.gallonWaterCoolers
      state.pages              = config.pages
      state.settings           = config.settings

      state.initialized = true
    },
    setIsProcessing(state, isProcessing) {
      state.isProcessing = isProcessing
    },
    setCurrentStep(state, step) {
      state.currentStep = step
    },
    addToCart(state, product) {

      // Check if we already have this product in the cart,
      // and if so, just increase the quantity.
      let existingProduct = null
      if (state.cart.length) {
        let temp = state.cart.filter(p => {
          return product.productId == p.productId && 
                 product.options.flavor == p.options.flavor &&
                 product.options.cooler == p.options.cooler
        })
        if (temp.length) {
          existingProduct = temp[0]
        }
      }

      if (existingProduct) {
        existingProduct.options.quantity += parseInt(product.options.quantity)
      } else {
        state.cart.push(product)
      }
      this.app.$cookies.set(state.cookieName, JSON.stringify(state.cart))
    },
    removeFromCart(state, index) {
      state.cart.splice(index, 1)
      this.app.$cookies.set(state.cookieName, JSON.stringify(state.cart))
    },
    updateCartItemQuantity(state, payload) {
      let item = state.cart[payload.index]
      item.options.quantity = parseInt(payload.quantity)
      state.cart.splice(payload.index, 1, item)
      this.app.$cookies.set(state.cookieName, JSON.stringify(state.cart))
    },
    clearCart(state) {
      state.cart = []
      state.offer = null
      this.app.$cookies.set(state.cookieName, JSON.stringify(state.cart))
      this.app.$cookies.set(state.cookieName + '-offer', '')
    },
    addOfferToCart(state, offer) {
      state.offer = offer
      this.app.$cookies.set(state.cookieName + '-offer', JSON.stringify(state.offer))
    },
    removeOfferFromCart(state) {
      state.offer = null
      this.app.$cookies.remove(state.cookieName + '-offer')
    },
    setProductFilter(state, payload) {
      if (state.productFilters[payload.filter] == payload.val) {
        state.productFilters[payload.filter] = null
      } else {
        state.productFilters[payload.filter] = payload.val
      }
    },
    resetProductFilters(state) {
      state.productFilters = {
        brand: null,
        category: null,
        flavor: null,
        size: null,
      }
    }
  },
  actions: {
    init(context) {
      axios.get(window.ajaxurl, {
          params: {
            action: 'load_online_store_config',
          }
        })
        .then(response => {
          context.commit('initialize', response.data)
        })

      // Set default product filter
      let urlParams = new URLSearchParams(window.location.search)
      let categorySlug = urlParams.get('c')

      if (categorySlug) {
        let category = context.state.productCategories.filter(category => {
          return category.slug == categorySlug
        })

        if (category.length) {
          context.dispatch('setProductFilter', { filter: 'category', val: category[0].id })
        }
      }
    },
    setIsProcessing(context, isProcessing) {
      context.commit('isProcessing', isProcessing)
    },
    setCurrentStep(context, step) {
      context.commit('setCurrentStep', step)
    },
    setPageMetaInfo(context) {
      if (
        router.currentRoute && 
        router.currentRoute.value && 
        router.currentRoute.value.params &&
        router.currentRoute.value.params.productId
      ) {
        const productId = router.currentRoute.value.params.productId
        const product = context.state.products.find(product => product.id == productId)

        if (product) {
          document.title = product.name + ' | ' + context.state.siteName
          return
        }
      }

      if (context.state.siteName) {
        document.title = context.state.siteName
      }
    },
    updateNavItemCounter(context) {
      let numItems = context.getters.numCartItems
      document.querySelectorAll('.cart-items-counter').forEach(counter => {
        counter.innerHTML = numItems
        counter.classList.remove('d-none')
      })
    },
    addToCart(context, product) {
      // Check if we already have this product in the cart,
      // and if so, calculate the max number that can be added,
      // if a max quantity for the product has been set.
      let existingProduct = null
      if (context.state.cart.length) {
        let temp = context.state.cart.filter(p => {
          return product.productId == p.productId && product.options.flavor == p.options.flavor
        })

        if (temp.length) {
          existingProduct = temp[0]
        }
      }

      if (existingProduct) {
        let p = context.getters.getProductById(existingProduct.productId)
        let numToAdd = product.options.quantity
        let maxQty = p.maximumQuantity
        if (maxQty) {
          if (numToAdd > maxQty - existingProduct.options.quantity) {
            numToAdd = maxQty - existingProduct.options.quantity
          }
        }

        // Set the new quantity to add
        product.options.quantity = numToAdd
      }

      context.commit('addToCart', product)
      context.dispatch('updateNavItemCounter')
    },
    removeFromCart(context, index) {

      // Remove the offer if the product being removed is gallow water.
      const productInfo = this.state.cart[index]
      const product = context.getters.getProductById(productInfo.productId)
      if (product && product.type && product.type == 'gallon-water') {
        context.commit('removeOfferFromCart')
      }

      context.commit('removeFromCart', index)
      context.dispatch('updateNavItemCounter')
    },
    updateCartItemQuantity(context, payload) {
      context.commit('updateCartItemQuantity', payload)
      context.dispatch('updateNavItemCounter')
    },
    addOfferToCart(context, offer) {
      context.commit('addOfferToCart', offer)
    },
    removeOfferFromCart(context) {
      context.commit('removeOfferFromCart')
    },
    setProductFilter(context, payload) {
      context.commit('setProductFilter', payload)
    },
    goToOrderSummary(context) {
      router.push({ name: 'order-summary' })
    },
    goToProducts(context) {
      router.push({ name: 'products' })
    },
    resetProductFilters(context) {
      context.commit('resetProductFilters')
    },
    submitOrder(context, customerData) {
      let data = {
        customer: customerData,
        cart: [],
        offer: context.state.offer,
      }

      if (context.state.cart) {
        let product

        for (let i = 0; i < context.state.cart.length; i++) {
          data.cart.push({
            product: context.state.cart[i].productId,
            cooler: context.state.cart[i].options.cooler || null,
            quantity: context.state.cart[i].options.quantity,
            flavor: context.state.cart[i].options.flavor,
          })
        }
      }

      context.commit('setIsProcessing', true)
      
      axios.post(window.ajaxurl + '?action=online_store_order', data)
        .then(response => {
          if (response.data.errors) {
            context.dispatch('showFormErrors', response.data.errors)

          } else {
            context.commit('clearCart')
            context.dispatch('updateNavItemCounter')
            
            router.push({ name: 'products' })
            
            swal({
              title: "Thank You!",
              text: 'Your order has been received successfully.',
              icon: "success",
            })

            // window.location = '/thank-you'
          }
        })
        .catch(error => {
          console.log(error)
          context.dispatch('showFormErrors', error.response.data.errors)
        })
        .finally(() => {
          context.commit('setIsProcessing', false)
        })
    },
    showFormErrors(context, errors) {
      let msg = document.createElement('ul')
      msg.classList.add('text-start')
      msg.innerHTML = '<li>' + errors.join('</li><li>') + '</li>'
      
      swal({
        title: "Whoops!",
        content: msg,
        icon: "error",
      })
    }
  },
  getters: {
    countCategoryProducts: (state) => (category) => {
      let num = 0
      state.products.forEach(product => {
        if (product.categories) {
          product.categories.forEach(c => {
            if (c.id == category.id) {
              num++
              return
            } 
          })
        }
      })
      return num
    },
    countBrandProducts: (state) => (brand) => {
      let num = 0
      state.products.forEach(product => {
        if (product.brands) {
          product.brands.forEach(b => {
            if (b.id == brand.id) {
              num++
              return
            } 
          })
        }
      })
      return num
    },
    getDefaultProducts: (state) => {
      return state.products.filter(product => {
        return product.type == 'default' || product.type === null
      })
    },
    getFilteredProducts: (state, getters) => {
      return getters.getDefaultProducts.filter(product => {

        // Category
        if (state.productFilters.category) {
          if (! product.categories) {
            return false
          }

          let hasCategory = product.categories.filter(category => {
            return state.productFilters.category == category.id
          })

          if (! hasCategory.length) {
            return false
          }
        }
        
        // Brand
        if (state.productFilters.brand) {
          if (! product.brands) {
            return false
          }

          let hasBrand = product.brands.filter(brand => {
            return state.productFilters.brand == brand.id
          })

          if (! hasBrand.length) {
            return false
          }
        }
        
        // Size
        if (state.productFilters.size && state.productFilters.size != product.size) {
          return false
        }
        
        // Flavor
        if (state.productFilters.flavor) {
          let hasFlavor = product.flavors.filter(flavor => {
            return state.productFilters.flavor == flavor.name
          })
        
          if (! hasFlavor.length) {
            return false
          }
        }
        
        return true
      })
    },
    getProductById: (state) => (productId) => {
      let product = state.products.filter(product => {
        return product.id == productId
      })
      if (product.length) {
        return product[0]
      }
      return null
    },
    getProductsByCategorySlug: (state) => (slugs, limit) => {
      limit = limit || 1

      let products = state.products.filter(product => {
        if (product.categories) {
          for (let i = 0; i < product.categories.length; i++) {
            if (slugs.includes(product.categories[i].slug)) {
              return true
            }
          }
        }
      })
      
      return products.slice(0, limit)
    },
    getRandomProducts: (state) => (limit) => {
      limit = limit || 1
      
      // Only default products.
      let products = state.products.filter(product => {
        return product.type == 'default' || product.type == null
      })

      let currentIndex = products.length, 
          temporaryValue, 
          randomIndex

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = products[currentIndex]
        products[currentIndex] = products[randomIndex]
        products[randomIndex] = temporaryValue
      }
      
      return products.slice(0, limit)
    },
    getBottleFreeCoolers: (state) => {
      return state.products.filter(product => {
        return product.type == 'bottle-free-cooler'
      })
    },
    getGallonWater: (state) => {
      return state.products.filter(product => {
        return product.type == 'gallon-water'
      })
    },
    getDefaultGallonWater: (state) => {
      let p = state.products.filter(product => {
        return product.type == 'gallon-water' &&
               product.isDefault == true
      })
      
      if (p.length) {
        return p[0]
      }
      
      return { name: '' }
    },
    cartOnlyContainsBfcs: (state, getters) => {
      let cartItems = getters.cartItems
      if (cartItems.length == 1) {
        if (getters.getProductById(cartItems[0].product.id).type == 'bottle-free-cooler') {
          return true
        }
      }
      return false
    },
    cartItems: (state) => {
      let items = []
      let product = null
      
      if (state.initialized) {
        if (state.cart.length) {
          for (let item in state.cart) {
              
            product = state.products.filter(p => {
              return p.id == state.cart[item].productId
            })
            
            if (product.length) {
              items.push({
                product: product[0],
                options: state.cart[item].options
              })
            }
          }
        }
      }
      return items
    },
    numCartItems: (state, getters) => {
      let num = 0
      if (state.initialized) {
        if (state.cart.length) {
          for (let item in state.cart) {
            if (state.cart[item].options && state.cart[item].options.quantity) {
              num += parseInt(state.cart[item].options.quantity)
            }
          }
        }
      }
      return num
    },
    getCartItemSubtotal: (state, getters) => (item) => {
      let subtotal = getters.getProductUnitCost(item) * item.options.quantity

      if (item.options.type == 'gallon-water' && item.options.cooler) {
        let cooler = item.options.cooler
        if (cooler) {
          subtotal += parseFloat(cooler.price)
        }
      }

      return subtotal
    },
    cartSubTotal: (state, getters) => {
      let total = 0
      let cartItems = getters.cartItems

      if (cartItems.length) {
        for (let item in cartItems) {
          if (cartItems[item].options && cartItems[item].options.quantity) {
            total += getters.getCartItemSubtotal(cartItems[item])
          }
        }
      }

      return total
    },
    cartOfferDiscount: (state, getters) => {
      let discount = 0

      if (state.offer) {
        if (state.offer.discount) {
          discount += parseFloat(state.offer.discount)
        }

        // Special Case: Free First Month Cooler Rental
        // The discount is equal to the cost of the selected cooler.
        if (state.offer.name == 'Free First Month Cooler Rental') {
          let cartItems = getters.cartItems
          if (cartItems.length) {
            for (let item in cartItems) {
              if (
                cartItems[item].options && 
                cartItems[item].options.type == 'gallon-water' && 
                cartItems[item].options.cooler
              ) {
                discount += parseFloat(cartItems[item].options.cooler.price)
              }
            }
          }
        }
      }

      return discount
    },
    cartHasOfferDiscount: (state, getters) => {
      return getters.cartOfferDiscount > 0
    },
    cartDiscount: (state, getters) => {
      let cartItems = getters.cartItems
      for (let item in cartItems) {
        if (cartItems[item].options && cartItems[item].options.offer) {
          if (cartItems[item].product.offer.discount) {
            return cartItems[item].product.offer.discount
          }
        }
      }
      return 0
    },
    cartHasDiscount: (state, getters) => {
      let cartItems = getters.cartItems
      for (let item in cartItems) {
        if (cartItems[item].options && cartItems[item].options.offer) {
          if (cartItems[item].product.offer.discount) {
            return true
          }
        }
      }
      return false
    },
    cartTotal: (state, getters) => {
      let total = getters.cartSubTotal - getters.cartOfferDiscount - getters.cartDiscount
      if (total < 0) {
        total = 0
      }
      return total + getters.getDeliveryFee + getters.getFuelSurcharge + getters.refundableBottleDeposit
    },
    getDeliveryFee(state) {
      if (state.settings.deliveryFee) {
        return parseFloat(state.settings.deliveryFee)
      }
      return 0
    },
    getFuelSurcharge(state) {
      if (state.settings.fuelSurcharge) {
        return parseFloat(state.settings.fuelSurcharge)
      }
      return 0
    },
    refundableBottleDeposit: (state, getters) => {
      let fee = 0

      if (state.settings.bottleDepositFee) {

        let cartItems = getters.cartItems
        if (cartItems.length) {
          for (var item in cartItems) {
            if (cartItems[item].product.type == 'gallon-water') {
              fee += (parseFloat(state.settings.bottleDepositFee) * cartItems[item].options.quantity)
            }
          }
        }
      }

      return fee
    },
    getProductUnitCost: (state, getters) => (product) => {
      let flavorPrice = getters.getProductFlavorPrice(product)
      return flavorPrice || product.product.price
    },
    getDeposit: (state, getters) => (product) => {
      return product.deposit || 0
    },
    getProductFlavor: (state) => (product) => {
      if (product.options && product.options.flavor && product.product.flavors) {
        let flavor = product.product.flavors.filter(function(flavor) {
          return flavor.id == product.options.flavor
        })
        if (flavor.length) {
          return flavor[0]
        }
      }
      return null
    },
    getProductFlavorName: (state, getters) => (product) => {
      let flavor = getters.getProductFlavor(product)
      if (flavor) {
        return flavor.name
      }
      return null
    },
    getProductFlavorPrice: (state, getters) => (product) => {
      let flavor = getters.getProductFlavor(product)
      if (flavor) {
        return flavor.price
      }
      return null
    },
  },
  strict: process.env.NODE_ENV !== 'production'
})
